const disabledOpacity = 0.5

export default {
  disabledOpacity,
}
